<template>
  <div>
    <div v-for="(intervenant, index) in intervenants"
         :key="index"
         class="mgt-20px">
      <div class="has-text-weight-bold"
           v-if="intervenant.titre">
        {{ intervenant.titre }}
      </div>
      <div class="has-text-weight-bold"
           v-else>
        {{ intervenant.titre }}
      </div>
      <b-field class="mgb-0">
        <router-link-blank v-if="afficherLien"
          :to="{ name: 'c.bodac.clients/contacts-client', params: {id: intervenant.tiersId}}"
          :message="getIntituleOrNomComIntervenant(intervenant)"/>
        <span v-else>{{getIntituleOrNomComIntervenant(intervenant)}}</span>
        <b-tooltip :label="$t('detailFacture.clients.clientExonerationTva')"
                   v-if="intervenant.annonceur && func.getExonerationTva(intervenant)"
                   type="is-warning"
                   position="is-right">
          <b-icon icon="earth-arrow-right" class="is-cursor-pointer mgl-5px mgt-5px"
                  type="is-warning" size="is-small">
          </b-icon>
        </b-tooltip>
        <b-tooltip :label="$t('detailFacture.clients.prospect')"
                   v-if="intervenant.tiers.prospect"
                   type="is-warning"
                   position="is-right">
          <b-icon icon="account-search" class="is-cursor-pointer mgl-5px mgt-5px"
                  type="is-warning" size="is-small">
          </b-icon>
        </b-tooltip>
      </b-field>
      <div> {{  intervenant.adressePostale.intitule2 }} </div>
      <div> {{  intervenant.adressePostale.intitule3 }} </div>
      <div>{{ intervenant.adressePostale.adresse1 }}</div>
      <div v-if="intervenant.adressePostale.adresse2">
        {{ intervenant.adressePostale.adresse2 }}
      </div>
      <div>
        {{ intervenant.adressePostale.codePostal }}
        <span v-if="intervenant.adressePostale.codePostal
              && intervenant.adressePostale.ville">
                -
              </span>
        {{ intervenant.adressePostale.ville }}
      </div>
      <div>{{ intervenant.adressePostale.pays }}</div>
      <div v-if="isDestinataire(intervenant) && canDisplayDestinataireComptableLabel">
        {{ $t('detail.commande.intervenant.destinataireComptableLabel') }}
      </div>
      <div v-if="intervenant.tvaIntracommunautaire">
        {{ $t('detail.commande.intervenant.tvaIntracommunautaire',
        { val: intervenant.tvaIntracommunautaire }) }}
      </div>
      <div v-else-if="intervenant.tiers
               && intervenant.tiers.tvaIntracommunautaire">
        {{ $t('detail.commande.intervenant.tvaIntracommunautaire',
        { val: intervenant.tiers.tvaIntracommunautaire }) }}
      </div>
      <multi-contact-intervenant :intervenant="intervenant"/>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';
import getExonerationTva from '@/services/tiers/getExonerationTva';
import {
  TYPE_FACTURE, SENS_VENTE,
} from '@/configuration/devisConf';

export default {
  props: {
    intervenants: {
      type: Array,
      required: true,
    },
    afficherLien: {
      type: Boolean,
      required: false,
      default: true,
    },
    dcf: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      func: { getExonerationTva },
    };
  },
  components: {
    routerLinkBlank,
    multiContactIntervenant,
  },
  computed: {
    canDisplayDestinataireComptableLabel() {
      if (!this.dcf) return false;
      return this.dcf.sens === SENS_VENTE
        && this.dcf.type === TYPE_FACTURE;
    },
  },
  methods: {
    getIntituleOrNomComIntervenant(intervenant) {
      return intervenant.adressePostale && intervenant.adressePostale.intitule1
        ? intervenant.adressePostale.intitule1 : intervenant.nomCommercial;
    },
    isDestinataire(intervenant) {
      return intervenant.destinataireComptable === true;
    },
  },
};
</script>
